import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./classroomCell.module.scss";

interface ClassroomCellProps {
  isLastItem?: boolean;
  classroom: {
    label: string;
    isSpecial?: boolean;
  };
}

const ClassroomCell = ({ isLastItem = true, classroom }: ClassroomCellProps) => {
  const { t } = useTranslation();

  return (
    <span className={styles.classroomCell}>
      {classroom?.label}
      {!isLastItem && !classroom?.isSpecial && ", "}
      {!!classroom?.isSpecial && (
        <span className={styles.classroomCell_special}>
          {t("booking.classroom-tags.special")} {!isLastItem && ", "}
        </span>
      )}
    </span>
  );
};

export default ClassroomCell;
